export default "__VITE_ASSET__D_aS2zXl__"